@if(expandMenuDrawer$ | async){}
<div stSideDrawer [isOpen]="isOpen()" [direction]="'right'" [maxWidth]="this.maxWidth()">
  <ng-content select="top-header-filters-section-mobile"></ng-content>
</div>